function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import { Link as RouterLink, useNavigation } from "react-router-dom";
import cc from "classcat";
import { twMerge } from "tailwind-merge";
import Spinner from "./Spinner";
import useGeneratePath from "../../vendor/router/generatePath";
var Button = /*#__PURE__*/ forwardRef(function RefButton(_param, ref) {
    var children = _param.children, className = _param.className, _param_variant = _param.variant, variant = _param_variant === void 0 ? "primary" : _param_variant, _param_size = _param.size, size = _param_size === void 0 ? "medium" : _param_size, _param_block = _param.block, block = _param_block === void 0 ? false : _param_block, _param_pilled = _param.pilled, pilled = _param_pilled === void 0 ? false : _param_pilled, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_loading = _param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_iconRight = _param.iconRight, iconRight = _param_iconRight === void 0 ? null : _param_iconRight, _param_leftIconWhileNotLoading = _param.leftIconWhileNotLoading, leftIconWhileNotLoading = _param_leftIconWhileNotLoading === void 0 ? null : _param_leftIconWhileNotLoading, _param_type = _param.type, type = _param_type === void 0 ? "button" : _param_type, _param_isLink = _param.isLink, isLink = _param_isLink === void 0 ? false : _param_isLink, to = _param.to, _param_params = _param.params, params = _param_params === void 0 ? {} : _param_params, _param_query = _param.query, query = _param_query === void 0 ? {} : _param_query, onClick = _param.onClick, props = _object_without_properties(_param, [
        "children",
        "className",
        "variant",
        "size",
        "block",
        "pilled",
        "disabled",
        "loading",
        "iconRight",
        "leftIconWhileNotLoading",
        "type",
        "isLink",
        "to",
        "params",
        "query",
        "onClick"
    ]);
    var generatePath = useGeneratePath();
    var navigation = useNavigation();
    var isLoading = loading || isLink && navigation.state === "loading";
    if (isLoading) {
        disabled = true;
    }
    var combinedCc = twMerge(cc([
        "outline-none ring-offset-1 focus:ring-2 inline-flex justify-center items-center gap-2 rounded-xl border border-transparent transition-all no-underline",
        {
            "py-2 px-6 text-sm": size === "small",
            "py-3 px-7 text-base": size === "medium",
            "py-3 px-20 text-base": size === "large"
        },
        {
            "ring-red-450": variant === "danger",
            "ring-blue-550": variant === "primary",
            "ring-green-500": variant === "success",
            "ring-offset-0": variant === "light"
        },
        {
            "border border-gray-200 dark:border-gray-600": variant === "light"
        },
        {
            "bg-blue-550 !text-gray-50": variant === "primary" && !disabled,
            "bg-gray-50 dark:bg-blue-775": variant === "light" && !disabled,
            "bg-indigo-100 dark:!text-gray-200 dark:bg-gray-650 !text-blue-550": variant === "secondary" && !disabled,
            "bg-red-450 !text-gray-50": variant === "danger" && !disabled,
            "bg-green-500 !text-gray-50": variant === "success" && !disabled
        },
        {
            "hover:bg-blue-700": variant === "primary" && !disabled,
            "hover:bg-blue-500": variant === "light" && !disabled,
            "hover:border-blue-550": variant === "secondary" && !disabled,
            "hover:bg-red-600": variant === "danger" && !disabled,
            "hover:bg-green-600": variant === "success" && !disabled,
            "hover:border-blue-550 hover:bg-indigo-100 hover:!text-blue-550 ": variant === "light" && !disabled
        },
        {
            "focus:ring-0 focus:!text-blue-550 focus:border-blue-550 dark:focus:border-blue-550 focus:bg-indigo-100": variant === "light"
        },
        {
            "rounded-full": pilled
        },
        {
            "w-full": block
        },
        {
            "cursor-not-allowed ": disabled
        },
        {
            "bg-blue-500 !text-gray-50": variant === "primary" && disabled,
            "bg-indigo-100 !text-blue-600 dark:!text-gray-200 dark:bg-gray-625": variant === "secondary" && disabled,
            "bg-red-500 !text-gray-50": variant === "danger" && disabled,
            "bg-green-500 !text-gray-50": variant === "success" && disabled
        },
        {
            "opacity-50": disabled
        },
        {
            "min-h-[50px] min-w-[50px]": leftIconWhileNotLoading && isLoading && !children
        },
        className
    ]));
    if (typeof children === "function") {
        return children({
            className: combinedCc,
            disabled: disabled
        }, {
            IconRight: iconRight,
            Loader: loading && /*#__PURE__*/ React.createElement(Spinner, null)
        });
    }
    var buttonContent = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "hidden",
            {
                "grid items-center": isLoading || leftIconWhileNotLoading
            },
            {
                "md:-ml-[6px] md:-mr-[5px] md:pl-[12.5px]": (isLoading || leftIconWhileNotLoading) && children
            }
        ]))
    }, isLoading && /*#__PURE__*/ React.createElement(Spinner, {
        size: "small",
        className: cc([
            {
                "md:-ml-[20.5px]": children
            }
        ]),
        variant: variant === "secondary" ? "primary" : "secondary"
    }), !isLoading && leftIconWhileNotLoading && /*#__PURE__*/ React.createElement("div", {
        className: cc([
            {
                "md:-ml-[25px]": children
            }
        ])
    }, leftIconWhileNotLoading)), children, iconRight);
    if (isLink) {
        if (!to) {
            throw new Error("Button with isLink: ".concat(isLink, ' needs to have  "to" which was ').concat(to, ", it might also have objects for params and query but these are not required"));
        }
        if (props.onClick) {
            throw new Error("Button with isLink: ".concat(isLink, " does not support onClick which was ").concat(props.onClick, ", it prevents default onClick if disabled/loading"));
        }
        if (to) {
            var pathname = generatePath(to, params, query);
            return /*#__PURE__*/ React.createElement(RouterLink, {
                ref: ref,
                to: pathname,
                className: combinedCc,
                /*{...props}*/ //? Needs onClick to prevent since Link does not support disabled prop //Todo maybe also call its onclick??
                onClick: function(e) {
                    return disabled && e.preventDefault();
                }
            }, buttonContent);
        }
    }
    return /*#__PURE__*/ React.createElement("button", _object_spread({
        ref: ref,
        className: combinedCc,
        disabled: disabled,
        type: type,
        onClick: onClick
    }, props), buttonContent);
});
Button.propTypes = {
    size: PropTypes.oneOf([
        "small",
        "medium",
        "large"
    ]),
    variant: PropTypes.oneOf([
        "primary",
        "danger",
        "secondary",
        "light",
        "success"
    ]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    block: PropTypes.bool,
    pilled: PropTypes.bool,
    loading: PropTypes.bool,
    type: PropTypes.string,
    isLink: PropTypes.bool,
    to: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    params: PropTypes.object,
    query: PropTypes.object,
    children: PropTypes.oneOfType([
        PropTypes.node.isRequired,
        PropTypes.func.isRequired
    ]),
    iconRight: PropTypes.node,
    leftIconWhileNotLoading: PropTypes.node,
    onClick: PropTypes.func
};
export default Button;
